import React, { useContext, SyntheticEvent, FunctionComponent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

//MUI
import Box from "@mui/material/Box";
import DialogActions from "@mui/material/DialogActions";
import Toolbar from "@mui/material/Toolbar";

//Custom Components
import DraggableDialog from "@/ui/Dialog/DraggableDialog";
import DialogHeader from "@/ui/Dialog/DialogHeader";
import DialogToolbarHeading from "@/ui/Dialog/DialogToolbarHeading";
import DialogToolbarButtonClose from "@/ui/Dialog/ToolbarButtons/DialogToolbarButtonClose";
import ToolbarFillContent from "@/ui/Toolbar/ToolbarFillContent";
import DialogBody from "@/ui/Dialog/DialogBody";
import DialogContext from "@/ui/DialogContext/DialogContext";
import KatoviNamjeneTable from "./KatoviNamjeneTable";
import ObjektiSlikeView from "./ObjektiSlikeView";

//Types
import { IDialogProps } from "@/@types/ui/DialogContext";
import RadniSastanciCommentBlock from "./RadniSastanciCommentBlock";

const KatoviDialog: FunctionComponent<IDialogProps> = (props) => {
  const dialogContext = useContext(DialogContext);
  const { t } = useTranslation();
  const [changed, setChanged] = useState<boolean>(false);

  const { selectedObjekt, katovi, dc, povrsina, onSave, onDialogClose } = props

  const handleClose = (evt: SyntheticEvent) => {
    dialogContext.hideDialog();
    onDialogClose({ dataChanged: changed, action: 'update' });
  };

  return (
    <DraggableDialog open={true} maxWidth={"lg"} onClose={handleClose}>
      <DialogHeader>
        <Toolbar variant="dense" disableGutters={true}>
          <DialogToolbarHeading>{selectedObjekt.id} - {t("buttons.katovi")}</DialogToolbarHeading>
          <ToolbarFillContent />
          <DialogToolbarButtonClose onClick={handleClose} />
        </Toolbar>
      </DialogHeader>
      <DialogBody>
        <Box m={2}>

          <Box m={0} style={{ height: "60%", position: "relative" }}>
            <ObjektiSlikeView
              imgData={{
                kat: katovi.length - 1,
                ukupno: povrsina as number
              }}
              selectedObjekt={selectedObjekt}
              baseRecordPath={'operations/objekti/'}
            />
          </Box>

          <Box m={0} style={{ height: "40%" }}>
            <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "row" }}>
              <div style={{ width: "100%", height: "100%" }}>
                <KatoviNamjeneTable
                  selectedObjekt={selectedObjekt}
                  katovi={katovi}
                  dc={dc}
                />
              </div>
            </div>
          </Box>

          <Box m={0} style={{ height: "100%" }}>
            <RadniSastanciCommentBlock selectedRecord={selectedObjekt} onSave={(text) => {onSave(text, selectedObjekt); setChanged(true);}}></RadniSastanciCommentBlock>
          </Box>

        </Box>
      </DialogBody>
      <DialogActions>
      </DialogActions>
    </DraggableDialog>
  );
}

export default KatoviDialog;
